import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { Button } from "@/web/components/ui/button";
import { Input } from "@/web/components/ui/input";
import { Label } from "@/web/components/ui/label";

export default function AccountRegister() {
  return (
    <>
      <Helmet><title>Create account | Cool Wave</title></Helmet>
      <section className="container max-w-md py-14">
        <h1 className="mb-6 text-3xl font-bold">Create account</h1>
        <form className="space-y-4">
          <div>
            <Label htmlFor="name">Name</Label>
            <Input id="name" className="mt-1.5" />
          </div>
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" className="mt-1.5" />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" className="mt-1.5" />
          </div>
          <Button type="button" className="w-full" disabled>Create account (coming soon)</Button>
        </form>
        <p className="mt-6 text-sm text-body">
          Already have an account? <Link to="/account/login" className="font-medium text-brand hover:underline">Sign in</Link>
        </p>
      </section>
    </>
  );
}
